import { api } from './networkService';

class PostTypeService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/post-type`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch post type error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/post-type`);
            return response.data;
        } catch (error) {
            console.error('Fetch post type error:', error);
            throw error;
        }
    }

    static async add(postType) {
        try {
            const cleanedPostType = Object.fromEntries(
                Object.entries(postType).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/post-type`, cleanedPostType);
            return response;
        } catch (error) {
            console.error('Add post type error:', error);
            throw error;
        }
    }

    static async update(postType) {
        try {
            const { id, ...info } = postType;
            const cleanedPostType = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );
            const response = await api.put(`api/user/post-type/${id}`, cleanedPostType);
            return response;
        } catch (error) {
            console.error('Update post type error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/post-type/${id}`);
            return response;
        } catch (error) {
            console.error('Delete post type error:', error);
            throw error;
        }
    }
}

export default PostTypeService;
